import apiService, { HOST ,showPdfNewTab } from "./BaseApi";
import store from '@/store/index'
import Utils from "@/scripts/Utils";
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
const generatePdf = async (endpoint, params) => {
    let response = await apiService.post(endpoint, { ...params, env: Utils.getEnv(), currentUserId: store.state.currentUser?.uid })
    return response;
}
const downloadPdf = async (response) => {  
    if (response.status === 200 && response.data.signedUrl) showPdfNewTab(response.data.signedUrl)
    else showErrorSnackBar("Erro ao gerar proposta. Tente novamente!")
    showPdfNewTab(signedUrl)
}
const WaterFixApi = {
    downloadProposal: async (pdfName, params) => {
        let response = await generatePdf('/waterfix/proposal', params)
        downloadPdf(response, `${pdfName}_PROPOSTA_GERAL`)
    },
    downloadPhotoReport: async (pdfName, params) => {
        return await generatePdf('/waterfix/photo-report', params)
        // downloadPdf(response, `${pdfName}_RELATÓRIO_FOTOGRÁFICO`)
    },
    downloadPhotoReportProject: async (pdfName, params) => {
        return await generatePdf('/waterfix/project/photo-report', params)
        // downloadPdf(response, `${pdfName}_RELATÓRIO_FOTOGRÁFICO`)
    },
    downloadReturnTerm: async (pdfName, params) => {
        let response = await generatePdf('/waterfix/return-term', params)
        downloadPdf(response, `${pdfName}_TERMO_DE_DEVOLUCAO`)
    },
    downloadCompromiseTerm: async (pdfName, params) => {
        let response = await generatePdf('/waterfix/compromise-term', params)
        downloadPdf(response, `${pdfName}_TERMO_DE_CIENCIA`)
    },
    downloadInstallationTerm: async (pdfName, params) => {
        return await generatePdf('/waterfix/installation-term', params)
        // downloadPdf(response, `${pdfName}_TERMO_DE_INSTALACAO`)
    },
    downloadInstallationTermProject: async (pdfName, params) => {
        return await generatePdf('/waterfix/project/installation-term', params)
        // downloadPdf(response, `${pdfName}_TERMO_DE_INSTALACAO`)
    },

    downloadInspectionTerm: async (pdfName, params) => {
        let response = await generatePdf('/waterfix/inspection-term', params)
        downloadPdf(response, `${pdfName}_TERMO_DE_VISTORIA`)
    },
    downloadServiceOrder: async (pdfName, params) => {
        let response = await generatePdf('/waterfix/service-order', params)
        downloadPdf(response, `${pdfName}_ORDEM_DE_SERVICO`)
    },
};

export default WaterFixApi;
